<template>
    <BaseModal
        :isVisible="modalStatus"
        title="Check-List do Veículo"
        size="xl"
        @close="clean"
    >
        <template v-slot:content>
            <!-- Cabeçalho com informações do veículo -->
            <vehicle-header
                :vehicle-data="dataModal"
                @open-user-modal="openModalUser"
            />

            <!-- Abas para navegação -->
            <ul
                class="nav nav-tabs nav-fill tab-navigation"
                id="checkTabs"
                role="tablist"
            >
                <li class="nav-item">
                    <a
                        class="nav-link active"
                        id="checkout-tab"
                        data-toggle="tab"
                        href="#checkout-content"
                        role="tab"
                        aria-controls="checkout-content"
                        aria-selected="true"
                    >
                        <i class="fas fa-sign-out-alt mr-2"></i> Check-Out
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        id="checkin-tab"
                        data-toggle="tab"
                        href="#checkin-content"
                        role="tab"
                        aria-controls="checkin-content"
                        aria-selected="false"
                    >
                        <i class="fas fa-sign-in-alt mr-2"></i> Check-In
                    </a>
                </li>
            </ul>

            <div class="tab-content p-3 border border-top-0 rounded-bottom bg-white" id="checkTabsContent">
                <!-- Aba de Check-Out -->
                <div
                    class="tab-pane fade show active"
                    id="checkout-content"
                    role="tabpanel"
                    aria-labelledby="checkout-tab"
                >
                    <check-form
                        v-if="dataModal && dataModal.checkout"
                        :check-data="dataModal.checkout"
                        :checklist-items="checklist_items"
                        check-type="checkout"
                        @open-lightbox="openLightbox"
                    />

                    <div v-else class="no-data-container">
                        <i class="fas fa-exclamation-circle text-warning"></i>
                        <p>Informações de Check-Out não disponíveis.</p>
                    </div>
                </div>

                <!-- Aba de Check-In -->
                <div
                    class="tab-pane fade"
                    id="checkin-content"
                    role="tabpanel"
                    aria-labelledby="checkin-tab"
                >
                    <check-form
                        v-if="dataModal && dataModal.checkin && dataModal.reserve_status && dataModal.reserve_status.id == '5'"
                        :check-data="dataModal.checkin"
                        :checklist-items="checklist_items"
                        check-type="checkin"
                        @open-lightbox="openLightbox"
                    />

                    <div
                        v-else
                        class="no-data-container"
                    >
                        <i class="fas fa-info-circle text-info"></i>
                        <p>Check-In não realizado.</p>
                        <p class="sub-info">
                            Devolução estimada para:
                            <span class="date-highlight">{{ dataModal ? dataModal.devolution_date : 'N/A' }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import '../../../assets/css/vehicle-checkout.css';
import BaseModal from "../../Base/BaseModal.vue";
import VehicleHeader from "./VehicleHeader.vue";
import CheckForm from "./CheckForm.vue";

export default {
    name: "VehicleCheckoutModal", // Nome do componente em inglês
    components: {
        BaseModal,
        VehicleHeader,
        CheckForm
    },
    props: {
        modalStatus: {
            type: Boolean,
            default: false
        },
        dataModal: {

            default: () => ({})
        }
    },
    data() {
        return {
            // checklist_items - itens do checklist
            checklist_items: []
        };
    },
    mounted() {
        // Buscar itens do checklist ao montar o componente
        this.getChecklistItens();
    },
    methods: {
        // openLightbox - abre visualizador de imagens
        openLightbox(object) {
            this.$emit("OpenLightbox", object);
        },

        // openModalUser - abre modal com dados do usuário
        openModalUser(object) {
            this.$emit("OpenModalUser", object);
        },

        // clean - limpa e fecha o modal
        clean() {
            this.$emit("changeModal", false);
        },

        // getChecklistItens - busca itens do checklist da API
        getChecklistItens() {
            const self = this;
            const api = self.$store.state.api + "checklistItems?status=1";

            self.$http.get(api).then(response => {
                self.checklist_items = response.data.data;
                self.ciCount = response.data.count;
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Modals/Checklist/ChecklistModal.vue